import { Stack,Typography } from "@mui/material";
import { avaliacaoType,ChecklistReportType,ChecklistSubitemReport } from "../../../../types/reports/types";
import IconsRender from "../../../ChecklistV2/IconsRender";
import ImagesCmp from "../../../ImagesCmp";
import ImagesCmpAssinatura from "../../../ImagesCmpAssinatura";

const RenderSwitch = (param: ChecklistSubitemReport, showNotSelected: boolean, selected: ChecklistReportType) => {
  const listStyle = (index: number) => ({
    display: `${!showNotSelected && !param?.selecionados?.[index] ? "none" : ""}`,
    wordBreak: "break-word",
    listStyleType: `${param.selecionados && param.selecionados[index] ? "square" : "circle"} `,
    fontWeight: `${param.selecionados && param.selecionados[index] ? "600" : "500"} `,
    marginLeft: `${param.selecionados && param.selecionados[index] ? "20px" : "10px"} `,
  });

  const avaliaStyle = (index: number, elem: avaliacaoType, arr: avaliacaoType[]) => ({
    display: `${!showNotSelected && param.nota !== index ? "none" : ""}`,
    listStyleType: `${((param.nota || param.nota === 0) && param.nota === index) || (param.nota === -1 && elem === arr[arr.length - 1]) ? "square" : "circle"} `,
    fontWeight: `${((param.nota || param.nota === 0) && param.nota === index) || (param.nota === -1 && elem === arr[arr.length - 1]) ? "600" : "500"} `,
    marginLeft: `${((param.nota || param.nota === 0) && param.nota === index) || (param.nota === -1 && elem === arr[arr.length - 1]) ? "20px" : "10px"} `,
    wordBreak: "break-word",
  });

  const Comentario = ({ value }: { value: string }) => {
    return (
      <Typography variant="subtitle2" fontSize={13} color="textDisabled" fontWeight={600} component="p">
        Comentário:{" "}
        <Typography sx={{ wordBreak: "break-word" }} component="span" variant="subtitle2" fontSize={13} color="textDisabled">
          {value}
        </Typography>
      </Typography>
    );
  };

  switch (param.tipo) {
    case "multiple":
    case "unique":
      return (
        <div style={{ pageBreakInside: "avoid" }}>
          <Typography fontWeight={700} variant="subtitle2" color="textDisabled">
            Resposta:
          </Typography>
          {param?.selecao?.map((elem, index) => {
            return (
              <Typography variant="subtitle2" color="textDisabled" component="li" sx={listStyle(index)} key={index}>
                {elem}
              </Typography>
            );
          })}
          {param.tipo === "multiple" ? param.ocorrencia && <Comentario value={String(param.ocorrencia)} /> : param.obs && <Comentario value={String(param.obs)} />}
        </div>
      );
    case "avaliacao":
      return (
        <div style={{ pageBreakInside: "avoid" }}>
          <Typography fontWeight={700} variant="subtitle2" color="textDisabled">
            Resposta:
          </Typography>
          {param?.avaliacao?.map((elem, index, arr) => {
            return (
              <Typography variant="subtitle2" component="li" color="textDisabled" key={index} sx={avaliaStyle(index, elem, arr)}>
                {elem.valor} - {elem.nome}
              </Typography>
            );
          })}
          {param.ocorrencia && <Comentario value={String(param.ocorrencia)} />}
        </div>
      );
    case "list":
      return (
        <>
          <Typography fontWeight={700} variant="subtitle2" color="textDisabled">
            Resposta:
          </Typography>
          {(param?.selecionados as { texto: string }[])?.map((elem, index) => {
            return (
              <Typography
                component="li"
                key={index}
                color="textDisabled"
                fontWeight={600}
                variant="subtitle2"
                sx={{
                  listStyleType: "circle",
                  paddingLeft: "10px",
                  wordBreak: "break-word",
                }}>
                {elem.texto}
              </Typography>
            );
          })}
          {param.obs && <Comentario value={param.obs} />}
        </>
      );
    case "textoLongo":
    case "hora":
    case "email":
    case "telefone":
    case "rg":
    case "cpfcnpj":
    case "cep":
    case "placa":
    case "textoCurto":
    case "numero":
      return (
        <>
          {param.ocorrencia && (
            <Typography fontWeight={600} variant="subtitle2" color="textDisabled">
              Resposta: {param.ocorrencia}
            </Typography>
          )}
          {param.obs && <Comentario value={param.obs} />}
        </>
      );
    case "data":
      return (
        <>
          {param.ocorrencia && (
            <Typography fontWeight={600} variant="subtitle2" color="textDisabled">
              Resposta: {typeof param.ocorrencia === "number" ? new Date(param.ocorrencia).toLocaleDateString("pt-BR") : param.ocorrencia}
            </Typography>
          )}
          {param.obs && <Comentario value={param.obs} />}
        </>
      );
    case "assinatura":
      return (
        <>
          {param.assinatura && (
            <>
              <Typography fontWeight={600} variant="subtitle2" color="textDisabled">
                Resposta:
              </Typography>
              <ImagesCmpAssinatura images={[param.assinatura]} selected={selected} />
            </>
          )}
          {param.obs && <Comentario value={param.obs} />}
        </>
      );
    case "valorMedida":
      return (
        <div style={{ pageBreakInside: "avoid" }}>
          {param.ocorrencia && (
            <Typography fontWeight={700} variant="subtitle2" color="textDisabled">
              <Stack direction="row" alignItems="center" justifyContent="flex-start">
                Resposta: <IconsRender value={param.subtipo as string} /> | {param.ocorrencia}
              </Stack>
            </Typography>
          )}
          {param.img && <ImagesCmp images={param.img} />}
          {param.obs && <Comentario value={param.obs} />}
        </div>
      );
    default:
      return <></>;
  }
};

export default RenderSwitch;
